module.exports = __webpack_public_path__ + "static/img/1083.1c03380.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1083.jpg
// module id = 265
// module chunks = 0